    import React, { useState } from "react";
    import db from "../Firebase";
    import { collection, addDoc, serverTimestamp } from "firebase/firestore";
    import emailjs from "emailjs-com";

    const InquiryForm = ({ onClose }) => {
    const [formData, setFormData] = useState({ name: "", email: "",  mobile:"", message: "" });
    const [message, setMessage] = useState({ text: "", type: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
        // Save inquiry to Firestore
        await addDoc(collection(db, "inquiries"), { ...formData, timestamp: serverTimestamp() });

        // Send email using EmailJS
        await emailjs.send(
            "service_9gkr6hu",  
            "template_d6e822d", 
            {
            name: formData.name,
            email: formData.email,
            mobile: formData.mobile,
            message: formData.message,
            },
            "vS1fGTreJ2Hxj2m1V" 
        );

        setMessage({ text: "Inquiry submitted successfully!", type: "success" });

        // Reset form fields
        setFormData({ name: "", email: "", message: "" });

        // Close popup after 1.5 seconds
        setTimeout(() => {
            setMessage({ text: "", type: "" });
            if (onClose) onClose(); // Call onClose function if provided
        }, 1500);
        
        } catch (error) {
        console.error("Error submitting inquiry: ", error);
        setMessage({ text: "Failed to submit inquiry. Please try again.", type: "error" });

        setTimeout(() => setMessage({ text: "", type: "" }), 3000);
        }
    };

    return (
        <div className="popup">
        <div className="popup-content">
            <button className="close-btn" onClick={onClose}>×</button>
            <h3 className="text-dark mb-3 text-center" style={{ fontFamily: 'HurmeGeometricSans1, sans-serif' }}>
  Request a CallBack
</h3>

            {message.text && (
            <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}>
                {message.text}
            </div>
            )}
            <form onSubmit={handleSubmit}>
            <input type="text" name="name" className="form-control mb-3" placeholder="Your Name" value={formData.name} onChange={handleChange} required  style={{ fontFamily: 'HurmeGeometricSans1, sans-serif' }}/>
            <input type="email" name="email" className="form-control mb-3" placeholder="Your Email" value={formData.email} onChange={handleChange} required  style={{ fontFamily: 'HurmeGeometricSans1, sans-serif' }}/>
            <input type="number" name="mobile" className="form-control mb-3" placeholder="Your Phone" value={formData.mobile} onChange={handleChange} required style={{ fontFamily: 'HurmeGeometricSans1, sans-serif' }} />
            <textarea name="message" placeholder="Your Message" className="form-control" value={formData.message} onChange={handleChange} required style={{ fontFamily: 'HurmeGeometricSans1, sans-serif' }} />
            <button type="submit" className="btn btn-dark mt-3" style={{ borderRadius:"20px" ,fontFamily: 'HurmeGeometricSans1, sans-serif',background:" #d2ab67",border:"none"}}>Submit</button>
            </form>
        </div>
        </div>
    );
    };

    export default InquiryForm;
